<script>
import Layout from "@/views/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import store from "@/state/store";

export default {
  beforeRouteEnter(to, from, next) {
    const userType = store.getters["auth/getUser"].user_type;
    const permissions = store.getters["auth/permissions"];
    if (
      (userType === 1 || userType === 3) &&
      permissions.includes("HR_CONFIG")
    ) {
      next();
    } else {
      alert("You are not allowed to access this page. You will be redirected.");
      next("/");
    }
  },
  page: {
    title: "Authorization Gate Settings",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  async mounted() {
    await this.loadSetting();
  },
  data() {
    return {
      title: "Authorization Gate Settings",
      items: [
        { text: "IHUMANE" },
        { text: "Dashboard", href: "/" },
        { text: "Authorization Gate Settings", active: true },
      ],
      enabled: true,
      updatedBy: null,
      saving: false,
    };
  },
  methods: {
    async loadSetting() {
      const data = await this.$store.dispatch(
        "settings/fetchEnforceAuthorization"
      );
      this.enabled = !!data?.enforce;
      this.updatedBy = data?.updated_by ?? null;
    },
    async onToggle(value) {
      this.saving = true;
      try {
        const data = await this.$store.dispatch(
          "settings/updateEnforceAuthorization",
          value
        );
        this.enabled = !!data?.enforce;
        this.updatedBy = data?.updated_by ?? null;
        this.apiResponseHandler(
          value
            ? "Pending authorization gate is now enforced for all users."
            : "Pending authorization gate is now disabled for all users.",
          "Settings Updated"
        );
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h5 class="mb-3">Pending authorization gate</h5>
            <p class="text-muted">
              When enforced, employees with pending supervisor authorizations
              are redirected away from new leave, timesheet, and travel forms.
              The setting is stored in the database and applies globally.
            </p>

            <b-form-group label="Enforce pending authorization checks">
              <b-form-checkbox
                v-model="enabled"
                switch
                size="lg"
                :disabled="saving"
                @change="onToggle"
              >
                {{ enabled ? "On — gate enforced" : "Off — gate ignored" }}
              </b-form-checkbox>
            </b-form-group>

            <div class="mt-4 p-3 bg-light rounded">
              <p class="mb-0">
                <strong>Last updated by user id:</strong>
                {{ updatedBy != null ? updatedBy : "—" }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
